import {
  Bot,
  Brain,
  Database,
  FileText,
  FolderOpen,
  Lock,
  Mail,
  Map,
  Network,
  Paintbrush,
  Palette,
  Rocket,
  Shield,
  Terminal,
  Users,
  Users2,
  Workflow,
  Box,
  type LucideIcon,
} from 'lucide-react';

/**
 * Atlas module nodes carry only the icon *name* (string) in metadata —
 * we can't serialize React components into the DB. This map resolves
 * the name back to a lucide-react component at render time.
 *
 * Adding a new module: pick a lucide name, register it here, set it on
 * the atlas node's metadata.iconName. If the name isn't registered we
 * fall back to a neutral box so the dashboard never throws.
 */
const ICON_MAP: Record<string, LucideIcon> = {
  Bot,
  Brain,
  Database,
  FileText,
  FolderOpen,
  Lock,
  Mail,
  Map,
  Network,
  Paintbrush,
  Palette,
  Rocket,
  Shield,
  Terminal,
  Users,
  Users2,
  Workflow,
};

export function resolveModuleIcon(name: string | undefined | null): LucideIcon {
  if (!name) return Box;
  return ICON_MAP[name] ?? Box;
}

interface Props {
  name: string | undefined | null;
  className?: string;
}

export function ModuleIcon({ name, className }: Props) {
  const Icon = resolveModuleIcon(name);
  return <Icon className={className} />;
}
